import { useState, useEffect, useRef, useCallback } from 'preact/hooks'

export function useIntersectionObserver(options = { rootMargin: '0px', threshold: 0 }) {
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null)
  const [node, setNode] = useState<Element | undefined>(undefined)
  const observer = useRef<IntersectionObserver>(null)

  const disconnect = useCallback(() => {
    if (observer.current) {
      observer.current.disconnect()
    }
  }, [])

  useEffect(() => {
    if (observer.current) disconnect()

    observer.current = new IntersectionObserver(([updatedEntry]) => {
      setEntry(updatedEntry)
    }, options)

    const { current: currentObserver } = observer

    if (node) currentObserver.observe(node)

    return () => {
      currentObserver.disconnect()
    }
  }, [node, disconnect])

  return { setNode, entry }
}
